export const SCOPE = 'catalog';

export const DEFAULT_WIDTH = 256;

export const WIDTH_IN_SYSTEM_PAGE = 190;
